var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBriefcase({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.532 3.55h-2.318V2.102c0-.654-.538-1.186-1.398-1.186H5.984c-.86 0-1.398.532-1.398 1.186V3.55H2.468A2.471 2.471 0 000 6.02v7.049c0 1.111.904 1.816 2.016 1.816h11.968c1.111 0 2.016-.705 2.016-1.816v-7.05a2.471 2.471 0 00-2.468-2.468zM5.727 2.102c0-.14-.09-.246-.143-.246h4.448c.183 0 .242.106.242.246V3.55H5.727V2.102zm9.333 10.966c0 .793-.483.676-1.076.676H2.016c-.593 0-1.076.117-1.076-.676V8.676a2.031 2.031 0 00.509.228l4.79 1.17v.387c0 .608.494 1.101 1.1 1.101H8.66c.607 0 1.101-.493 1.101-1.1v-.387l4.79-1.17a2.033 2.033 0 00.508-.228v4.39zM7.179 10.46V9.135a.16.16 0 01.16-.16H8.66a.16.16 0 01.16.16v1.326a.16.16 0 01-.16.161H7.34a.16.16 0 01-.161-.16zm7.88-3.495c0 .473-.299 1.084-.746 1.228l-4.552.913a1.103 1.103 0 00-1.1-1.073H7.34c-.598 0-1.086.479-1.101 1.073l-4.552-.913C1.24 8.05.94 7.44.94 6.966V6.02A1.53 1.53 0 012.468 4.49h11.064a1.53 1.53 0 011.528 1.528v.947z"
  })));
}

export default SvgBriefcase;